import { KnaufPlaster } from './knauf-plaster.enum';
import { KnaufSellerLocation } from './knauf-sellers-locations';
import { Ankieta } from './ankieta';
import { KnaufMosaicColor } from './knauf-mosaic-color';
import { KnaufColor } from './knauf-color';
import { KnaufPalettes } from './knauf-palettes.enum';
import { Layer } from './layer';
export enum ProjectType {
    predefined,
    user
}

export class Project {
    public projectType: ProjectType = ProjectType.predefined;
    public knaufPalette: KnaufPalettes = KnaufPalettes.invalid;
    public selectedColors: KnaufColor[] = [];
    public selectedMosaic: KnaufMosaicColor = null;
    public projectImageFile: string;
    public orgImageFile: string;
    public ankieta: Ankieta = new Ankieta();
    public calculator = {
        plaster: {
            meters: '0',
            gramatura: 3,
            buckets: 0
        },
        mosaic: {
            meters: '0',
            gramatura: 0,
            buckets: 0
        }
    }
    public closestSellers: KnaufSellerLocation[] = [];
    public selectedKanufPlaster: KnaufPlaster = KnaufPlaster.invalid;
    layers: Layer[] = [];

    static getCopy(project: Project) {
        let copy  = (JSON.parse(JSON.stringify(project)));
        copy.ankieta = new Ankieta().deserialize(copy.ankieta);
        return copy;
    }
}
